/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
}

export enum DocumentTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  ENVELOPE = "ENVELOPE",
  COVER_LETTER = "COVER_LETTER",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export enum EventTypeDto {
  SCAN_COMPLETE = "SCAN_COMPLETE",
  VEHICLE_ACQUISITION = "VEHICLE_ACQUISITION",
  VEHICLE_ACQUISITION_INITIALIZED = "VEHICLE_ACQUISITION_INITIALIZED",
  VEHICLE_ACQUISITION_ERROR = "VEHICLE_ACQUISITION_ERROR",
  PLACEMENT = "PLACEMENT",
  SHIPMENT = "SHIPMENT",
  SHIPMENT_CLOSED = "SHIPMENT_CLOSED",
  LAST_SCAN = "LAST_SCAN",
  SHIPMENT_ITEM_LOST = "SHIPMENT_ITEM_LOST",
  SHIPMENT_ITEM_CANCELED = "SHIPMENT_ITEM_CANCELED",
  SHIPMENT_ITEM_INITIALIZED = "SHIPMENT_ITEM_INITIALIZED",
  INITIALIZED = "INITIALIZED",
  STORED = "STORED",
  RELEASE_PREPARED = "RELEASE_PREPARED",
  RELEASED = "RELEASED",
}

export interface HistoryServiceEventPayloadDto {
  /** @format uuid */
  customerId: string;
  /** @format uuid */
  id: string;
  vin: string;
}

export interface PrinterProjectionDto {
  displayName: string;
  name: string;
  /** @format uuid */
  printerId: string;
}

export enum SourceSystemDto {
  SEA = "SEA",
  VDA = "VDA",
  VRS = "VRS",
  SLS = "SLS",
  FMS = "FMS",
  PMS = "PMS",
}

export interface TriggerLabelPrintDto {
  /** @format uuid */
  customerId: string;
  documentId: string;
  documentType: DocumentTypeDto;
  /** @format uuid */
  printerId: string;
  vin: string;
}

export interface UserProjectionDto {
  active?: boolean;
  firstname?: string;
  keycloakId?: string;
  lastname?: string;
  /** @format uuid */
  userId?: string;
  username?: string;
}

export interface VehicleHistoryDto {
  items: VehicleHistoryEventItemDto[];
}

export enum VehicleHistoryEventAttributeDto {
  DOCUMENT_LOCATION = "DOCUMENT_LOCATION",
  COR_NUMBER = "COR_NUMBER",
  COR_SERIAL = "COR_SERIAL",
  LICENSE_PLATE = "LICENSE_PLATE",
  TRACKING_NUMBER = "TRACKING_NUMBER",
  SHIPPING_CARRIER = "SHIPPING_CARRIER",
  SHIPPING_TYPE = "SHIPPING_TYPE",
  NOTE = "NOTE",
}

export interface VehicleHistoryEventItemDto {
  attributes: Record<string, string>;
  /** @format date-time */
  createdDate: string;
  /** @format uuid */
  customerId: string;
  documentId?: string;
  documentType?: DocumentTypeDto;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastScan?: string;
  system: SourceSystemDto;
  systemEventType: EventTypeDto;
  /** @format uuid */
  systemId: string;
  username: string;
  vin: string;
}

export interface VehicleHistoryItemListDto {
  items: VehicleItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface VehicleItemDto {
  customer?: CustomerProjectionDto;
  /** @format uuid */
  customerId?: string;
  vin?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Vehicle History Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Vhs<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags vehicle-history-controller
     * @name ListVehicles
     * @summary Returns a list of vehicles
     * @request GET:/api/v1/history/
     * @secure
     */
    listVehicles: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        q?: string;
        /** @uniqueItems true */
        customerIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<VehicleHistoryItemListDto, any>({
        path: `/api/v1/history/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vehicle-history-controller
     * @name FindVehiclesByDocumentId
     * @summary Returns a list of vehicles - it should be always just one
     * @request GET:/api/v1/history/by-document-id
     * @secure
     */
    findVehiclesByDocumentId: (
      query: {
        documentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VehicleItemDto[], any>({
        path: `/api/v1/history/by-document-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vehicle-history-trigger-controller
     * @name TriggerLabelPrint
     * @request POST:/api/v1/history/trigger/label
     * @secure
     */
    triggerLabelPrint: (data: TriggerLabelPrintDto, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/history/trigger/label`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vehicle-history-controller
     * @name GetHistory
     * @summary Get all history items of vehicle
     * @request GET:/api/v1/history/{customerId}/{vin}
     * @secure
     */
    getHistory: (customerId: string, vin: string, params: RequestParams = {}) =>
      this.request<VehicleHistoryDto, any>({
        path: `/api/v1/history/${customerId}/${vin}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name GetCustomer
     * @request GET:/api/v1/projection/customer/{customerId}
     * @secure
     */
    getCustomer: (customerId: string, params: RequestParams = {}) =>
      this.request<CustomerProjectionDto, any>({
        path: `/api/v1/projection/customer/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printer Projection
     * @name FindZebraPrinters
     * @summary Find first 50 ZEBRA printers
     * @request GET:/api/v1/projection/printer/zebra
     * @secure
     */
    findZebraPrinters: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrinterProjectionDto[], any>({
        path: `/api/v1/projection/printer/zebra`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Projection
     * @name FindUsers
     * @summary Find first 50 active users
     * @request GET:/api/v1/projection/user
     * @secure
     */
    findUsers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserProjectionDto[], any>({
        path: `/api/v1/projection/user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Projection
     * @name GetUserByUsername
     * @summary Get user by username
     * @request GET:/api/v1/projection/user/{username}
     * @secure
     */
    getUserByUsername: (username: string, params: RequestParams = {}) =>
      this.request<UserProjectionDto, any>({
        path: `/api/v1/projection/user/${username}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
